import { render, staticRenderFns } from "./WorkOrderCustomerSiteTab.vue?vue&type=template&id=5b04a913"
import script from "./WorkOrderCustomerSiteTab.vue?vue&type=script&lang=js"
export * from "./WorkOrderCustomerSiteTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports